import { StorageAdapter } from '../StorageAdapter';

export class LocalStorageAdapter extends StorageAdapter {
  constructor() {
    super(localStorage);
  }
}
